module.exports = __webpack_public_path__ + "fonts/SuisseIntl-Bold.4f885e0.woff2";